import tinytime from 'tinytime'

export function ensureDate(value) {
  if (value instanceof Date) {
    return value
  }

  return new Date(value)
}

export function inputTime(date) {
  if (!date) {
    return date || ''
  }

  return tinytime('{YYYY}-{Mo}-{DD}T{H}:{mm}', {
    padMonth: true,
    padHours: true,
    padDays: true
  }).render(date)
}

export function timezone(date) {
  if (typeof date.toLocaleTimeString === 'function') {
    return date.toLocaleTimeString('en-us', { timeZoneName:'short' }).split(' ')[2]
  }
  return ''
}

export function strftime (format, date) {
  // tinytime doesn't support timezones out of the box, add that under {Z}
  return tinytime(format.replace('{Z}', timezone(date))).render(date)
}

function roundTo(n, decimals) {
  return parseFloat(n.toFixed(decimals), 10)
}

export function timeAgo (start, end) {
  let elapsed = Math.abs(end.getTime() - start.getTime())
  let seconds = Math.round(elapsed / 1000)
  let minutes = Math.round(seconds / 60)
  let hours = roundTo(minutes / 60, 2)

  let time = seconds + ' sec'

  if (minutes >= 60) {
    time = hours + ' hrs'
  } else if (minutes >= 1) {
    time = minutes + ' min'
  }

  return time
}
